/**
 * Copyright © 2025 Delicious AI, LLC
 *
 */

import { gql } from '@apollo/client'

export const GET_SIMPLE_ACTION_GENERATOR = gql`
  query GetSimpleActionGenerator($id: ID!) {
    actionGenerator(id: $id) {
      id
      title
      description
      startDate
      endDate
      dueDateTime
      repeatSchedule
      actionType
      parentGenerator {
        id
        title
      }
      subGenerators {
        id
        title
        description
        dueDateTime
        actionType
        repeatSchedule
      }
    }
  }
`
